import "@quark/design/dist/index.css";
import "../index.css";

import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://1827e68d546147ff8e1d370ef0dc2acb@o391314.ingest.sentry.io/4504299497652224",
    integrations: [new Sentry.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

export default function MyApp({ Component, pageProps }) {
  return <Component {...pageProps} />;
}
